import React from 'react';
import Routes from './routes';
import { Router } from 'react-router-dom';
import UserProvider from './context';
import { history } from './history';
import EasterEggs from './components/easter/EasterEggs';


function App() {
  return (
    <UserProvider>
      <div className="App">
        <Router history={history}>
          <EasterEggs />
          <Routes />
        </Router>
      </div>
    </UserProvider>

  );
}

export default App; 
